import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';

/**
 * # UserNotification
 *
 * 사용자 알림
 */
export const UserNotification = types
  .model('UserNotification')
  // --------------------------------------------------------------------------
  .props({
    userNotiSid: types.maybeNull(types.number),
    notiTypeCd: types.maybeNull(CommonCd),
    notiYn: types.string,
    notiTime: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model userNotification --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IUserNotificationSnapshot>) => {
      const newProps = { ...self, ...props } as IUserNotification;
      (Object.keys(newProps) as TUserNotificationKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUserNotification = Instance<typeof UserNotification>;
type TUserNotificationSnapshot = SnapshotOut<typeof UserNotification>;

export interface IUserNotification extends TUserNotification {}
export type TUserNotificationKeys = keyof TUserNotificationSnapshot & string;
export interface IUserNotificationSnapshot extends TUserNotificationSnapshot {}
export const createUserNotification = () =>
  types.optional(UserNotification, {} as TUserNotification);
